export default __webpack_public_path__ + "static/media/SLSC.75d11c11.svg";